import {AnyNotFound} from './AnyNotFound';

export const ProcessNotFound = () => <AnyNotFound title="Oops! Process not found" />;
